<template>
  <div class="news">
    <div class="banner">
      <img src="../../../assets/goin/news/banner.png" alt="" />
    </div>
    <div class="xs-news">
      <div class="news-list">
        <template v-if="newsList[0]">
          <div class="news-top">
            <div class="news-date">
              {{ newsList[0].publish_time.slice(0, 10) }}
            </div>
            <div class="news-title">{{ newsList[0].title }}</div>
            <div class="news-desc">{{ newsList[0].news_desc }}</div>
            <div @click="toInfo(newsList[0])" class="news-detail">
              查看详情
            </div>
          </div>
        </template>
        <template v-for="(item, idx) in newsList">
          <div
            @click="toInfo(item)"
            class="news-item"
            v-if="idx !== 0"
            :key="idx"
          >
            <div class="time">
              <div class="f1">{{ item.publish_time.slice(8, 10) }}</div>
              <div class="f2">{{ item.publish_time.slice(0, 7) }}</div>
            </div>
            <div class="text">
              <div class="title">{{ item.title }}</div>
              <p>{{ item.news_desc }}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div @click="more" v-if="newsList.length < dataCount" class="more">
      <p>查看更多</p>
      <img src="../../../assets/goin/news/more.png" alt="" />
    </div>
    <div v-else class="nomore">
      <span>没有更多</span>
    </div>
  </div>
</template>

<script>
import WOW from '../../../../node_modules/wowjs/dist/wow'
import { newsList } from '@/api/news.js'
import Des from '@/util/des.js'

export default {
  data() {
    return {
      dataCount: null,
      newsList: [],
      page: {
        pageSize: 6,
        pageNum: 1
      }
    }
  },
  created() {
    this.news()
  },
  filters: {
    getString: function(str, a, b) {
      return str.slice(a, b)
    }
  },
  methods: {
    toInfo(data) {
      if (data.news_link) {
        window.open(data.news_link, '_blank')
      } else if (data.id) {
        let route = this.$router.resolve({ path: `/goin/news/details/${data.id}` })
        window.open(route.href, '_blank')
      }
    },
    more() {
      this.page.pageNum += 1
      this.news()
    },
    news() {
      const deskey = atob(localStorage.getItem('odeskey'))
      newsList({
        news_class_id: 2,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNum
      }).then(res => {
        this.dataCount = res.dataCount
        if (res.result === 1) {
          this.newsList.push(
            ...JSON.parse(Des.decryptByDES(res.dataList, deskey))
          )
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
p {
  margin: 0;
}
.news {
  .banner {
    img {
      width: 100%;
      vertical-align: top;
      border: none;
    }
  }
  .xs-news {
    padding-top: 60px;
  }
  .news-top {
    text-align: left;
    border-bottom: 2px solid #e4e4e4;
    padding-bottom: 60px;
    .news-date {
      font-size: 24px;
      font-weight: 400;
      color: #555555;
      line-height: 40px;
      margin-bottom: 29px;
    }
    .news-title {
      font-size: 30px;
      font-weight: 400;
      color: #595858;
      line-height: 53px;
      margin-bottom: 28px;
    }
    .news-desc {
      font-size: 24px;
      font-weight: 400;
      color: #595858;
      line-height: 36px;
      margin-bottom: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .news-detail {
      cursor: pointer;
      width: 240px;
      text-align: center;
      box-sizing: border-box;
      padding: 12px 0;
      border-radius: 5px;
      background: #4e8b46;
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      line-height: 37px;
    }
  }
  .news-list {
    width: 1440px;
    max-width: 1440px;
    margin: 0 auto;
    .news-item {
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid #e4e4e4;
      padding: 60px 0;
      .time {
        text-align: center;
        width: 105px;
        .f1 {
          font-size: 50px;
          font-weight: 400;
          color: #555555;
        }
        .f2 {
          font-size: 24px;
          font-weight: 400;
          color: #555555;
          line-height: 40px;
        }
      }
      .text {
        width: calc(1440px - 237px);
        text-align: left;
        .title {
          font-size: 30px;
          font-weight: 400;
          color: #595858;
          line-height: 53px;
          margin-bottom: 26.5px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        p {
          font-size: 16px;
          font-weight: 400;
          color: #595858;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
      &:last-child {
        border: none;
      }
      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 8px;
        background: #4e8b46;
        z-index: 1;
        transform: scale3d(1, 1, 1);
        transition: all 0.5s;
      }
      &:hover {
        &::before {
          height: 3px;
          width: 100%;
        }
        .title {
          color: #4e8b46;
        }
      }
    }
  }
}
.more {
  cursor: pointer;
  width: 1000px;
  border-radius: 15px;
  height: 72px;
  max-width: 1000px;
  margin: 15px auto 60px;
  background: #f5f8f4;
  font-size: 30px;
  font-weight: 400;
  color: #4e8b46;
  line-height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-left: 17.5px;
  }
}
.nomore {
  color: #a3b7ac;
  font-size: 20px;
  margin: 40px 0 40px;
  span {
    position: relative;

    &::before {
      width: 20px;
      height: 2px;
      position: absolute;
      top: 50%;
      left: -40px;
      background-color: #e4e4e4;
      display: inline-block;
      content: '';
    }

    &::after {
      width: 20px;
      height: 2px;
      position: absolute;
      top: 50%;
      right: -40px;
      background-color: #e4e4e4;
      display: inline-block;
      content: '';
    }
  }
}
</style>
